/**
 * Formatação de valor monetário — hoje só o `item_contratual.valor`
 * (`TP-049`). Um lugar só, mesma disciplina de `datas.ts`: se cada tela
 * formatasse por conta própria, o separador decimal brasileiro (vírgula)
 * divergiria do inglês (ponto) na primeira tela nova.
 */
const LOCALIDADE = 'pt-BR';

/** `R$ 1.234,50` */
export function formatarValorEmReais(valor: number): string {
  return new Intl.NumberFormat(LOCALIDADE, { style: 'currency', currency: 'BRL' }).format(valor);
}
